import { Data } from 'signup-constants/signupData/Data';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { Step } from 'signup-constants/Step';
import { getCurrentStep } from '../store/flow/selectors';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
export const getShouldPreFillCompanyName = (state, name, isCalledByBreeze = false) => {
  const userCompanyName = getSignupDataValue(state, Data.CompanyName);
  const shouldPreFillCompanyNameByFlowConfig = getFlowConfig().shouldPreFillCompanyName;
  const currentStep = getCurrentStep(state);
  const isAssignedToACQ168Variant_A = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0168, [ExperimentParameterGroup.Variant_A]);
  if (isCalledByBreeze) {
    return Boolean(name) && shouldPreFillCompanyNameByFlowConfig && currentStep !== Step.CompanyName;
  }
  if (isAssignedToACQ168Variant_A) {
    return Boolean(name) && shouldPreFillCompanyNameByFlowConfig && currentStep !== Step.CompanyName;
  }
  return !userCompanyName && Boolean(name) && shouldPreFillCompanyNameByFlowConfig && currentStep !== Step.CompanyName;
};